import styled from 'styled-components'

export const TruncatedLine = styled.div`
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`
